module.exports = __webpack_public_path__ + "media/about/CardsPreview-ab696fe8.jpg";